import React from 'react';
import { PackMeta, SortTh } from './StockPrimitives';

const TopSellingTab = ({ topSelling, allProducts, filtered, wacMap, topSort, setTopSort }) => {
  const productByCatalogId = Object.fromEntries(
    allProducts.map(p => [p.catalog_id || p.id, p])
  );

  const rows = filtered(topSelling, 'product_name').map(item => {
    const wac = wacMap[item.catalog_id] ?? null;
    const cost = wac != null ? wac * (item.quantity_sold || 0) : null;
    const profit = cost != null ? (item.revenue || 0) - cost : null;
    const profitPct = cost != null && cost > 0 ? (profit / cost) * 100 : null;
    return { ...item, _profit: profit, _profitPct: profitPct };
  });

  const sorted = [...rows].sort((a, b) => {
    let av, bv;
    switch (topSort.col) {
      case 'product_name':   av = (a.product_name || '').toLowerCase(); bv = (b.product_name || '').toLowerCase(); break;
      case 'quantity_sold':  av = a.quantity_sold ?? -Infinity; bv = b.quantity_sold ?? -Infinity; break;
      case 'revenue':        av = a.revenue ?? -Infinity; bv = b.revenue ?? -Infinity; break;
      case 'profit':         av = a._profit ?? -Infinity; bv = b._profit ?? -Infinity; break;
      default:               av = 0; bv = 0;
    }
    if (av < bv) return topSort.dir === 'asc' ? -1 : 1;
    if (av > bv) return topSort.dir === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className="overflow-x-auto w-full">
    <table className="w-full min-w-[560px] text-sm">
      <thead>
        <tr className="border-b border-border text-muted-foreground text-xs uppercase tracking-wide">
          <th className="text-left py-3 px-4 w-10">#</th>
          <SortTh col="product_name"  label="Product"  sort={topSort} setSort={setTopSort} />
          <SortTh col="quantity_sold" label="Qty Sold" sort={topSort} setSort={setTopSort} right />
          <SortTh col="revenue"       label="Sales ₹"  sort={topSort} setSort={setTopSort} right />
          <SortTh col="profit"        label="Profit ₹" sort={topSort} setSort={setTopSort} right />
          <th className="text-right py-3 px-4 pr-8 whitespace-nowrap">Profit %</th>
        </tr>
      </thead>
      <tbody>
        {sorted.map((item, i) => {
          const prod = productByCatalogId[item.catalog_id || item.product_id];
          const profitColor = item._profit == null ? '' : item._profit >= 0 ? 'text-emerald-600' : 'text-red-600';
          const pctColor    = item._profitPct == null ? '' : item._profitPct >= 0 ? 'text-emerald-600' : 'text-red-600';
          return (
            <tr key={i} className="border-b border-border last:border-0 hover:bg-muted/30">
              <td className="py-3 px-4 text-muted-foreground font-mono">{i + 1}</td>
              <td className="py-3 px-4">
                <span className="font-medium">{item.product_name}</span>
                {prod && <div className="mt-0.5"><PackMeta packSize={prod.pack_size} unit={prod.unit} /></div>}
              </td>
              <td className="py-3 px-4 text-right font-semibold">{item.quantity_sold}</td>
              <td className="py-3 px-4 text-right text-emerald-600 font-semibold">
                ₹{item.revenue?.toLocaleString('en-IN')}
              </td>
              <td className="py-3 px-4 text-right font-semibold">
                {item._profit != null
                  ? <span className={profitColor}>₹{Math.round(item._profit).toLocaleString('en-IN')}</span>
                  : <span className="text-muted-foreground/40 text-xs">—</span>
                }
              </td>
              <td className="py-3 px-4 pr-8 text-right font-semibold">
                {item._profitPct != null
                  ? <span className={pctColor}>{item._profitPct.toFixed(1)}%</span>
                  : <span className="text-muted-foreground/40 text-xs">—</span>
                }
              </td>
            </tr>
          );
        })}
        {sorted.length === 0 && (
          <tr><td colSpan={6} className="py-8 text-center text-muted-foreground">No sales data yet. Import sales data to see top sellers.</td></tr>
        )}
      </tbody>
    </table>
    </div>
  );
};

export default TopSellingTab;
